export enum CapacityType {
  LIMITED = 0,
  UNLIMITED = 1,
}
